// Store original product templates
const REGIMEN_PRODUCT_TEMPLATES = {};

// Handles to exclude from showing in the regimen slider
const REGIMEN_EXCLUDED_HANDLES = new Set([
  "shipping-protection-1",
  "mystery-gift-bpads",
  "mystery-gift-cleanser",
  "the-berry-antiox-eye-serum",
  "inveterate-subscription",
  "vip-gift",
]);

let REGIMEN_REFRESH_TIMEOUT_ID = null;
async function scheduleRegimenRefresh(delayMs = 0) {
  if (REGIMEN_REFRESH_TIMEOUT_ID) {
    clearTimeout(REGIMEN_REFRESH_TIMEOUT_ID);
  }
  return new Promise((resolve) => {
    REGIMEN_REFRESH_TIMEOUT_ID = setTimeout(async () => {
      try {
        await refreshCompleteRegimen();
        initRegimenSlider();
      } finally {
        resolve();
      }
    }, delayMs);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initCompleteRegimen();

  // Listen for cart updates
  document.body.addEventListener("click", (e) => {
    if (
      e.target.matches(
        "[data-remove-item], .cart__remove, .quantity__button"
      ) ||
      e.target.closest("[data-remove-item], .cart__remove, .quantity__button")
    ) {
      scheduleRegimenRefresh(600);
    }
  });

  document.addEventListener("cart:updated", (e) => {
    scheduleRegimenRefresh(200);
    if (typeof window.updateCartBubble === 'function') {
      window.updateCartBubble(e?.detail?.item_count);
    }
  });

  document.addEventListener("cart:refresh", (e) => {
    scheduleRegimenRefresh(200);
    if (typeof window.updateCartBubble === 'function') {
      window.updateCartBubble(e?.detail?.item_count);
    }
  });

  document.addEventListener("cart-drawer:updated", (e) => {
    scheduleRegimenRefresh(0);
    if (typeof window.updateCartBubble === 'function') {
      window.updateCartBubble(e?.detail?.item_count);
    }
  });

  // Observe cart-drawer for dynamic content replacements and re-init regimen
  const cartDrawerEl = document.querySelector("cart-drawer");
  if (cartDrawerEl && window.MutationObserver) {
    let drawerObserveTimeout = null;
    const observer = new MutationObserver((mutations) => {
      // Ignore mutations that occur within the regimen section to prevent
      // unnecessary rebuilds that reset the slider position
      const shouldRefresh = mutations.some((m) => {
        const target = m.target && m.target.nodeType === 1 ? m.target : null;
        if (!target) return false;
        return !target.closest('[data-regimen-section]');
      });

      if (!shouldRefresh) return;

      if (drawerObserveTimeout) clearTimeout(drawerObserveTimeout);
      drawerObserveTimeout = setTimeout(() => {
        scheduleRegimenRefresh(0);
      }, 100);
    });
    observer.observe(cartDrawerEl, { childList: true, subtree: true });
  }
});

// Persist slider state across re-inits
let REGIMEN_CURRENT_SLIDE = 0;

async function initCompleteRegimen() {
  await refreshCompleteRegimen();
  initRegimenSlider();
}

async function refreshCompleteRegimen() {
  const container = document.querySelector("[data-complete-regimen-slider]");
  const section = document.querySelector("[data-regimen-section]");

  if (!container || !section) return;

  try {
    // Fetch current cart
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();
updateRegimenSectionVisibility(cart);
    // Hide if cart is empty
    if (cart.item_count === 0) {
      section.style.display = "none";
      container.innerHTML = "";
      return;
    }

    section.style.display = "block";

    // Get cart product IDs as strings for consistent comparison
    const cartProductIds = new Set(
      cart.items.map((item) => item.product_id.toString())
    );

    // If no templates stored, fetch recommendations
    if (Object.keys(REGIMEN_PRODUCT_TEMPLATES).length === 0) {
  const products = container.querySelectorAll(
    ".complete-regimen-product[data-product-id]"
  );

  if (!products.length) {
    section.style.display = "none";
    return;
  }

  const cartProductIds = new Set(
    cart.items.map((item) => item.product_id.toString())
  );

  let visibleProducts = 0;

  products.forEach((productCard) => {
    const productId = productCard.dataset.productId;
    const handle = productCard.dataset.productHandle;

    /*
     * Hide product if:
     * 1. Already in cart
     * 2. Handle is excluded
     */
    if (
      cartProductIds.has(productId) ||
      REGIMEN_EXCLUDED_HANDLES.has(handle)
    ) {
      productCard.classList.add("hidden");
      return;
    }

    productCard.classList.remove("hidden");

    // Store template
    REGIMEN_PRODUCT_TEMPLATES[productId] =
      productCard.cloneNode(true);

    visibleProducts++;
  });

  if (visibleProducts === 0) {
    section.style.display = "none";
    return;
  }

  setupAddToCartHandlers();
} else {
      // Templates exist - rebuild the slider deterministically from templates
      // Clear the container to avoid stale/missing nodes after cart redraws
      container.innerHTML = "";

      // Re-append only products that are not currently in the cart
      Object.keys(REGIMEN_PRODUCT_TEMPLATES).forEach((productId) => {
        if (!cartProductIds.has(productId)) {
          const cardTemplate =
            REGIMEN_PRODUCT_TEMPLATES[productId].cloneNode(true);
          cardTemplate.classList.remove("hidden");
          container.appendChild(cardTemplate);
        }
      });

      // Re-setup handlers for all buttons
      setupAddToCartHandlers();

      // Check if we have any visible cards
      let visibleCards = container.querySelectorAll(
        ".complete-regimen-product:not(.hidden)"
      );

      // Recovery: if templates exist but nothing is visible while cart has items,
      // fetch fresh recommendations to repopulate templates and render
      if (visibleCards.length === 0 && cart.items && cart.items.length > 0) {
  try {
    const cartProductIds = new Set(
      cart.items.map((item) => item.product_id.toString())
    );

    const productCards = container.querySelectorAll(
      ".complete-regimen-product[data-product-id]"
    );

    let hasVisibleProduct = false;

    productCards.forEach((productCard) => {
      const productId = productCard.dataset.productId;
      const handle =
        productCard.dataset.productHandle ||
        productCard.dataset.handle ||
        "";

      // Product is available to show
      if (
        !cartProductIds.has(productId) &&
        !REGIMEN_EXCLUDED_HANDLES.has(handle)
      ) {
        hasVisibleProduct = true;
      }
    });

    if (hasVisibleProduct) {
      // At least one regimen product can be shown
      section.style.display = "";
    } else {
      // All selected regimen products are either
      // in cart or excluded
      section.style.display = "none";
    }

    setupAddToCartHandlers();
  } catch (error) {
    console.error("Error refreshing regimen section:", error);
  }
}

      // Do not toggle visibility here; keep section visible while cart has items
    }
  } catch (error) {
    console.error("Error refreshing complete regimen:", error);
  }
}

function updateRegimenSectionVisibility(cart) {
  const section = document.querySelector("[data-regimen-section]");

  if (!section) return;

  const container = section.querySelector(
    "[data-complete-regimen-slider]"
  );

  if (!container) return;

  const cartProductIds = new Set(
    cart.items.map((item) => item.product_id.toString())
  );

  const productCards = container.querySelectorAll(
    ".complete-regimen-product[data-product-id]"
  );

  let hasAvailableProduct = false;

  productCards.forEach((productCard) => {
    const productId = productCard.dataset.productId;
    const handle =
      productCard.dataset.productHandle ||
      productCard.dataset.handle ||
      "";

    if (
      !cartProductIds.has(productId) &&
      !REGIMEN_EXCLUDED_HANDLES.has(handle)
    ) {
      hasAvailableProduct = true;
    }
  });

  section.style.display = hasAvailableProduct ? "" : "none";
}

function setupAddToCartHandlers() {
  const container = document.querySelector("[data-complete-regimen-slider]");
  if (!container) return;

  const buttons = container.querySelectorAll("button[data-variant-id]");

  buttons.forEach((btn) => {
    // Clone to remove old listeners
    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);

    newBtn.addEventListener("click", async function (e) {
      e.preventDefault();

      if (this.disabled) return;

      const variantId = this.dataset.variantId;
      const originalText = this.textContent;

      this.textContent = "Adding...";
      this.disabled = true;
      this.classList.add("adding");

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
          }),
        });

        if (!response.ok) throw new Error("Failed to add");

        this.classList.remove("adding");
        this.classList.add("success");
        this.textContent = "Added!";

        // Refresh cart drawer
refreshCartDrawer();

// Immediately get the latest cart and update regimen section
fetch("/cart.js", { cache: "no-store" })
  .then((response) => response.json())
  .then((updatedCart) => {
    updateRegimenSectionVisibility(updatedCart);
  })
  .catch((error) => {
    console.error("Error updating regimen section:", error);
  });

        setTimeout(() => {
          this.classList.remove("success");
          this.textContent = originalText;
          this.disabled = false;
        }, 2000);
      } catch (error) {
        console.error("Error adding to cart:", error);
        this.classList.remove("adding");
        this.textContent = "Error";
        this.disabled = false;

        setTimeout(() => {
          this.textContent = originalText;
        }, 2000);
      }
    });
  });
}

function refreshCartDrawer() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      fetch("/cart?view=drawer")
        .then((res) => res.text())
        .then((html) => {
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer) {
            cartDrawer.classList.remove("is-empty");

            const parser = new DOMParser();
            const newDoc = parser.parseFromString(html, "text/html");
            const newDrawerContent = newDoc.querySelector("cart-drawer");
            if (newDrawerContent) {
              cartDrawer.innerHTML = newDrawerContent.innerHTML;
            }
          }

          // Update cart count
          if (typeof window.updateCartBubble === 'function') {
            window.updateCartBubble(cart.item_count);
          }

          setTimeout(() => {
            refreshCompleteRegimen();
            initRegimenSlider();
          }, 300);
        });

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: cart,
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: cart,
        })
      );
    })
    .catch((error) => console.error("Error refreshing cart:", error));
}

function initRegimenSlider() {
  const container = document.querySelector("[data-complete-regimen-slider]");
  const prevBtn = document.querySelector("[data-regimen-prev]");
  const nextBtn = document.querySelector("[data-regimen-next]");
  const section = document.querySelector("[data-regimen-section]");

  if (!container || !prevBtn || !nextBtn || !section) return;

  function getVisibleCards() {
    return container.querySelectorAll(
      ".complete-regimen-product:not(.hidden)"
    );
  }

  let currentSlide = window.REGIMEN_CURRENT_SLIDE || 0;

  function updateSlider() {
    const cards = getVisibleCards();
    const cardCount = cards.length;

    if (cardCount === 0) return;

    section.style.display = "block";

    const cardsPerSlide = 2; // change if needed
    const totalSlides = cardCount - cardsPerSlide + 1;

    currentSlide = Math.max(0, Math.min(currentSlide, totalSlides - 1));

    const cardWidth = cards[0].offsetWidth;

    // ✅ Get actual gap from CSS
    const styles = window.getComputedStyle(container);
    const gap = parseInt(styles.columnGap || styles.gap || 0);

    // ✅ Correct slide width calculation
    const slideWidth = cardWidth + gap;

    const offset = -(currentSlide * slideWidth);

    container.style.transform = `translateX(${offset}px)`;

    // Buttons state
    newPrevBtn.disabled = currentSlide === 0;
    newNextBtn.disabled = currentSlide >= totalSlides - 1;

    // Hide buttons if not needed
    if (cardCount <= cardsPerSlide) {
      newPrevBtn.style.opacity = "0";
      newPrevBtn.style.pointerEvents = "none";
      newNextBtn.style.opacity = "0";
      newNextBtn.style.pointerEvents = "none";
    } else {
      newPrevBtn.style.opacity = "1";
      newPrevBtn.style.pointerEvents = "auto";
      newNextBtn.style.opacity = "1";
      newNextBtn.style.pointerEvents = "auto";
    }

    window.REGIMEN_CURRENT_SLIDE = currentSlide;
  }

  function nextSlide() {
    const cards = getVisibleCards();
    const totalSlides = cards.length - 2 + 1;

    if (currentSlide < totalSlides - 1) {
      currentSlide++;
      updateSlider();
    }
  }

  function prevSlide() {
    if (currentSlide > 0) {
      currentSlide--;
      updateSlider();
    }
  }

  // ✅ Remove old listeners safely
  const newPrevBtn = prevBtn.cloneNode(true);
  const newNextBtn = nextBtn.cloneNode(true);

  if (prevBtn.parentNode) {
    prevBtn.parentNode.replaceChild(newPrevBtn, prevBtn);
  }

  if (nextBtn.parentNode) {
    nextBtn.parentNode.replaceChild(newNextBtn, nextBtn);
  }

  newPrevBtn.addEventListener("click", prevSlide);
  newNextBtn.addEventListener("click", nextSlide);

  // ✅ Ensure correct sizing after load + resize
  window.addEventListener("load", updateSlider);
  window.addEventListener("resize", updateSlider);

  updateSlider();
}

function escapeHtml(text) {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
}

function formatMoney(cents) {
  if (window.Shopify && window.Shopify.formatMoney) {
    return window.Shopify.formatMoney(cents);
  }
  return `₹${(cents / 100).toFixed(2)}`;
}

// Safely compute a product image URL from different API shapes
function getProductImageUrl(product) {
  try {
    let raw = "";
    if (product && product.featured_image) {
      if (typeof product.featured_image === "string") {
        raw = product.featured_image;
      } else if (typeof product.featured_image === "object") {
        raw = product.featured_image.url || product.featured_image.src || "";
      }
    } else if (product && product.images && product.images.length) {
      const first = product.images[0];
      raw = typeof first === "string" ? first : first.url || first.src || "";
    }
    return raw || "";
  } catch (_) {
    return "";
  }
}
